import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as person from '../check-in'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: person.RESOURCE.payload.dimension.partialId,
      partialId: person.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Snapshot,
    }),
    description: "Employee's response to the check-in",
    isOptional: false,
    name: 'Response',
    partialId: PartialId.Standard.create('response'),
    type: core.common.value.types.Intrinsic.Text,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
